var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewPayment({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 848 908",
    width: 848,
    height: 908,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff}.b{fill:#e0e0e0}.c{fill:#f5f5f5}.d{fill:#263238}.e{fill:#037cff}.f{fill:#619bef}.g{fill:#ae7461}.h{fill:#ffbf9d}.i{fill:#ff9a6c}.j{fill:#455a64}.k{fill:#fafafa}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m527.9 451.1h-274.3c-5.3 0-9.5-4.2-9.5-9.5v-407.4c0-5.3 4.2-9.6 9.5-9.6h274.3c5.3 0 9.6 4.3 9.6 9.6v407.4c0 5.3-4.3 9.5-9.6 9.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "b",
    d: "m527.7 452.2h-273.9c-5.9 0-10.7-4.9-10.7-10.8v-407.1c0-5.9 4.8-10.7 10.7-10.7h273.9c6 0 10.8 4.8 10.8 10.7v407.1c0 5.9-4.8 10.8-10.8 10.8zm-273.9-426.6c-4.8 0-8.7 3.9-8.7 8.7v407.1c0 4.8 3.9 8.7 8.7 8.7h273.9c4.8 0 8.7-3.9 8.7-8.7v-407.1c0-4.8-3.9-8.7-8.7-8.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m516.7 414.6h-244.1v-10h244.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m516.7 429.5h-244.1v-10h244.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m516.7 371.6h-244.1v-176.7h244.1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m515.5 225.5c0 0.3-54.6 0.6-121.8 0.6-67.3 0-121.9-0.3-121.9-0.6 0-0.2 54.6-0.5 121.9-0.5 67.2 0 121.8 0.3 121.8 0.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m304.7 371.6c-0.2 0-0.5-39.3-0.5-87.8 0-48.5 0.3-87.8 0.5-87.8 0.3 0 0.6 39.3 0.6 87.8 0 48.5-0.3 87.8-0.6 87.8z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m414.5 373.6c-0.2 0-0.5-39.7-0.5-88.8 0-49 0.3-88.8 0.5-88.8 0.3 0 0.6 39.8 0.6 88.8 0 49.1-0.3 88.8-0.6 88.8z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m469.4 373.6c-0.2 0-0.5-39.7-0.5-88.8 0-49 0.3-88.8 0.5-88.8 0.3 0 0.6 39.8 0.6 88.8 0 49.1-0.3 88.8-0.6 88.8z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m295.4 216.9h-14.3v-10.5h14.3z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m295.4 254.1h-14.3v-10.4h14.3z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m295.4 277.7h-14.3v-10.4h14.3z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m295.4 298.4h-14.3v-10.4h14.3z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m456.9 216.9h-30.2v-10.5h30.2z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m452.3 245.9h-20.8v-10.5h20.8z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m452.3 277.5h-20.8v-10.4h20.8z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m505 277.5h-20.8v-10.4h20.8z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m452.3 298.6h-20.8v-10.5h20.8z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m504.8 297.6h-20.8v-10.4h20.8z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m504.8 246.5h-20.8v-10.4h20.8z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m504.8 216.9h-24.1v-10.5h24.1z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m397.4 216.9h-78.9v-10.5h78.9z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m365.4 251.9h-46.9v-10.4h46.9z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m397.4 276.8h-78.9v-10.5h78.9z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m360.4 297.6h-41.9v-10.4h41.9z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m516.7 395.6h-47.3v-24h47.3z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m505 79.4h-105v-9.9h105z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m304.4 110.4h-25.7v-9.9h25.7z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m346.5 127.1h-68.5v-9.9h68.5z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m482.3 110.4h25.6v-9.9h-25.6z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m440.2 127.1h68.5v-9.9h-68.5z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m346.5 157.9h-68.5v-10h68.5z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m452.9 175.2h-174.9v-10h174.9z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m280.4 64.4h4.6v16.5h-4.6z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m304 64.4v16.5h-3.8l-7.3-8.8v8.8h-4.5v-16.5h3.8l7.3 8.8v-8.8z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m324 64.4l-7.1 16.5h-4.6l-7-16.5h5l4.5 10.7 4.5-10.7z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "b",
    d: "m323.9 72.7c0-5 3.8-8.6 9.1-8.6 5.3 0 9.2 3.6 9.2 8.6 0 4.9-3.9 8.5-9.2 8.5-5.3 0-9.1-3.6-9.1-8.5zm13.6 0c0-2.9-2-4.7-4.5-4.7-2.5 0-4.4 1.8-4.4 4.7 0 2.8 1.9 4.7 4.4 4.7 2.5 0 4.5-1.9 4.5-4.7z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m344.6 64.4h4.7v16.5h-4.7z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m351.7 72.7c0-5 3.9-8.6 9.1-8.6 3 0 5.5 1.1 7.1 3.1l-3 2.7c-1-1.3-2.3-1.9-3.9-1.9-2.7 0-4.6 1.8-4.6 4.7 0 2.8 1.9 4.7 4.6 4.7 1.6 0 2.9-0.7 3.9-2l3 2.7c-1.6 2-4.1 3.1-7.1 3.1-5.2 0-9.1-3.5-9.1-8.5z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m383.1 77.3v3.6h-13.2v-16.5h12.9v3.6h-8.3v2.8h7.3v3.5h-7.3v3z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m263.8 39.9c0 2.5-2 4.5-4.5 4.5-2.4 0-4.4-2-4.4-4.5 0-2.5 2-4.5 4.4-4.5 2.5 0 4.5 2 4.5 4.5z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m275.3 39.9c0 2.5-2 4.5-4.5 4.5-2.4 0-4.4-2-4.4-4.5 0-2.5 2-4.5 4.4-4.5 2.5 0 4.5 2 4.5 4.5z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m286.8 39.9c0 2.5-2 4.5-4.4 4.5-2.5 0-4.5-2-4.5-4.5 0-2.5 2-4.5 4.5-4.5 2.4 0 4.4 2 4.4 4.5z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m826.4 749.9h-274.3c-5.3 0-9.6-4.2-9.6-9.5v-407.4c0-5.3 4.3-9.6 9.6-9.6h274.3c5.3 0 9.5 4.3 9.5 9.6v407.4c0 5.3-4.2 9.5-9.5 9.5z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "b",
    d: "m826.2 750.9h-274c-5.9 0-10.7-4.8-10.7-10.7v-407.1c0-5.9 4.8-10.7 10.7-10.7h274c5.9 0 10.7 4.8 10.7 10.7v407.1c0 5.9-4.8 10.7-10.7 10.7zm-274-426.5c-4.7 0-8.6 3.9-8.6 8.7v407.1c0 4.8 3.9 8.7 8.6 8.7h274c4.8 0 8.7-3.9 8.7-8.7v-407.1c0-4.8-3.9-8.7-8.7-8.7z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m815.2 713.4h-244.1v-10h244.1z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m815.2 728.3h-244.1v-10h244.1z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m815.2 670.4h-244.1v-176.7h244.1z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m814 524.3c0 0.3-54.6 0.6-121.9 0.6-67.2 0-121.8-0.3-121.8-0.6 0-0.3 54.6-0.5 121.8-0.5 67.3 0 121.9 0.2 121.9 0.5z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m603.2 670.4c-0.3 0-0.5-39.3-0.5-87.8 0-48.5 0.2-87.8 0.5-87.8 0.3 0 0.6 39.3 0.6 87.8 0 48.5-0.3 87.8-0.6 87.8z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m713 672.4c-0.3 0-0.5-39.8-0.5-88.8 0-49 0.2-88.8 0.5-88.8 0.3 0 0.6 39.8 0.6 88.8 0 49-0.3 88.8-0.6 88.8z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m767.9 672.4c-0.3 0-0.5-39.8-0.5-88.8 0-49 0.2-88.8 0.5-88.8 0.3 0 0.6 39.8 0.6 88.8 0 49-0.3 88.8-0.6 88.8z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m593.9 515.7h-14.3v-10.5h14.3z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m593.9 552.9h-14.3v-10.4h14.3z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m593.9 576.5h-14.3v-10.4h14.3z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m593.9 597.2h-14.3v-10.4h14.3z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m755.4 515.7h-30.2v-10.5h30.2z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m750.8 544.6h-20.8v-10.4h20.8z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m750.8 576.3h-20.8v-10.4h20.8z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m803.5 576.3h-20.9v-10.4h20.9z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m750.8 597.4h-20.8v-10.5h20.8z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m803.3 596.4h-20.8v-10.5h20.8z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m803.3 545.3h-20.8v-10.4h20.8z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m803.3 515.7h-24.1v-10.5h24.1z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m695.9 515.7h-78.9v-10.5h78.9z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m663.9 550.7h-46.9v-10.4h46.9z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m695.9 575.6h-78.9v-10.5h78.9z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m658.9 596.4h-41.9v-10.5h41.9z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m815.2 694.4h-47.3v-24h47.3z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m803.5 378.2h-105v-9.9h105z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m602.9 409.2h-25.7v-9.9h25.7z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m645 425.9h-68.5v-10h68.5z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m780.7 409.2h25.7v-9.9h-25.7z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m738.7 425.9h68.5v-10h-68.5z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m645 456.7h-68.5v-10h68.5z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m751.3 474h-174.8v-10h174.8z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m578.9 363.2h4.6v16.5h-4.6z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m602.5 363.2v16.5h-3.8l-7.3-8.8v8.8h-4.6v-16.5h3.9l7.2 8.8v-8.8z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m622.4 363.2l-7 16.5h-4.6l-7-16.5h5l4.5 10.7 4.5-10.7z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "b",
    d: "m622.3 371.5c0-5 3.9-8.6 9.2-8.6 5.3 0 9.1 3.6 9.1 8.6 0 4.9-3.8 8.5-9.1 8.5-5.3 0-9.2-3.6-9.2-8.5zm13.6 0c0-2.9-1.9-4.7-4.4-4.7-2.5 0-4.5 1.8-4.5 4.7 0 2.8 2 4.7 4.5 4.7 2.5 0 4.4-1.9 4.4-4.7z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m643.1 363.2h4.6v16.5h-4.6z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m650.2 371.5c0-5.1 3.8-8.6 9.1-8.6 3 0 5.4 1.1 7 3.1l-2.9 2.7c-1.1-1.3-2.3-1.9-3.9-1.9-2.7 0-4.6 1.8-4.6 4.7 0 2.8 1.9 4.7 4.6 4.7 1.6 0 2.8-0.7 3.9-2l2.9 2.7c-1.6 2-4 3.1-7 3.1-5.3 0-9.1-3.5-9.1-8.5z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m681.6 376.1v3.6h-13.2v-16.5h12.9v3.6h-8.3v2.8h7.3v3.5h-7.3v3z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m562.3 338.7c0 2.5-2 4.5-4.5 4.5-2.5 0-4.5-2-4.5-4.5 0-2.5 2-4.5 4.5-4.5 2.5 0 4.5 2 4.5 4.5z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m573.8 338.7c0 2.5-2 4.5-4.5 4.5-2.4 0-4.5-2-4.5-4.5 0-2.5 2.1-4.5 4.5-4.5 2.5 0 4.5 2 4.5 4.5z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m585.3 338.7c0 2.5-2 4.5-4.5 4.5-2.4 0-4.4-2-4.4-4.5 0-2.5 2-4.5 4.4-4.5 2.5 0 4.5 2 4.5 4.5z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m653.8 21.3c20.3-16.7 50.6-16.6 70.9 0.1 1.8 1.5 4.3 1.8 6.1 0 1.5-1.5 1.8-4.6 0-6.1-11.7-9.6-26.3-15.2-41.5-15.3-15.2 0-29.9 5.6-41.6 15.2-1.8 1.5-1.6 4.6 0 6.1 1.8 1.8 4.3 1.5 6.1 0z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m668 36.4c12.2-9.9 30.3-9.8 42.4 0.1 1.8 1.5 4.4 1.8 6.1 0 1.6-1.5 1.9-4.6 0-6.1-7.7-6.3-17.2-10.1-27.3-10.1-10 0-19.5 3.7-27.3 10-1.8 1.5-1.5 4.6 0 6.1 1.8 1.8 4.3 1.5 6.1 0z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m699.9 49.1c0 5.9-4.8 10.7-10.7 10.7-5.9 0-10.6-4.8-10.6-10.7 0-5.8 4.7-10.6 10.6-10.6 5.9 0 10.7 4.8 10.7 10.6z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "none"
    }
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m473.2 58.4l1.8-4.3c15.7-36.2 49.6-61.4 88.7-64.3q7.5-0.6 15.1 0c36.2 2.7 70.4 25.1 87.8 57.4 10.2 19 15.5 41.8 31.8 55.7 21.3 18.2 52.7 14.5 80.1 9.9 27.4-4.6 58.8-8.2 80 10 13.3 11.5 19.5 29.5 20.9 47 3.9 46.5-22.6 92.2-60.6 118.3-38.1 26.2-86 34.6-132 31.8-64.4-4-128.8-30.6-172-79.2-43.2-48.7-62.4-120.5-41.6-182.3z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m837.2 387.5c0 24.6-19.9 44.5-44.5 44.5-24.6 0-44.5-19.9-44.5-44.5 0-24.6 19.9-44.5 44.5-44.5 24.6 0 44.5 19.9 44.5 44.5z"
  }))), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m857.3 884.5c0 0.3-194 0.5-433.3 0.5-239.3 0-433.3-0.2-433.3-0.5 0-0.3 194-0.5 433.3-0.5 239.3 0 433.3 0.2 433.3 0.5z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m361.8 521.9h-274.3c-5.2 0-9.5-4.2-9.5-9.5v-407.4c0-5.3 4.3-9.6 9.5-9.6h274.3c5.3 0 9.6 4.3 9.6 9.6v407.4c0 5.3-4.3 9.5-9.6 9.5z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "d",
    d: "m361.7 523h-274c-5.9 0-10.7-4.9-10.7-10.8v-407.1c0-5.9 4.8-10.7 10.7-10.7h274c5.9 0 10.7 4.8 10.7 10.7v407.1c0 5.9-4.8 10.8-10.7 10.8zm-274-426.6c-4.8 0-8.7 3.9-8.7 8.7v407.1c0 4.8 3.9 8.7 8.7 8.7h274c4.8 0 8.7-3.9 8.7-8.7v-407.1c0-4.8-3.9-8.7-8.7-8.7z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m350.7 485.4h-244.2v-10h244.2z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m350.7 500.3h-244.2v-10h244.2z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m350.7 442.4h-244.2v-176.7h244.2z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m349.4 296.3c0 0.3-54.5 0.6-121.8 0.6-67.3 0-121.8-0.3-121.8-0.6 0-0.2 54.5-0.5 121.8-0.5 67.3 0 121.8 0.3 121.8 0.5z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m138.7 442.4c-0.3 0-0.6-39.3-0.6-87.8 0-48.5 0.3-87.8 0.6-87.8 0.3 0 0.5 39.3 0.5 87.8 0 48.5-0.2 87.8-0.5 87.8z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m248.5 444.4c-0.3 0-0.6-39.7-0.6-88.8 0-49 0.3-88.8 0.6-88.8 0.3 0 0.5 39.8 0.5 88.8 0 49.1-0.2 88.8-0.5 88.8z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m303.4 444.4c-0.3 0-0.6-39.7-0.6-88.8 0-49 0.3-88.8 0.6-88.8 0.3 0 0.5 39.8 0.5 88.8 0 49.1-0.2 88.8-0.5 88.8z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m129.3 287.7h-14.2v-10.5h14.2z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m129.3 324.9h-14.2v-10.4h14.2z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m129.3 348.5h-14.2v-10.4h14.2z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m129.3 369.2h-14.2v-10.4h14.2z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m290.9 287.7h-30.2v-10.5h30.2z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m286.2 316.7h-20.8v-10.5h20.8z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m286.2 348.3h-20.8v-10.4h20.8z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m338.9 348.3h-20.8v-10.4h20.8z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m286.2 369.4h-20.8v-10.5h20.8z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m338.7 368.4h-20.8v-10.4h20.8z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m338.7 317.3h-20.8v-10.4h20.8z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m338.7 287.7h-24.1v-10.5h24.1z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m231.4 287.7h-79v-10.5h79z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m199.4 322.7h-47v-10.4h47z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m231.4 347.6h-79v-10.5h79z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m194.3 368.4h-41.9v-10.4h41.9z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m350.7 466.4h-47.3v-24h47.3z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m338.9 150.2h-105v-9.9h105z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m138.3 181.2h-25.6v-9.9h25.6z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m180.4 197.9h-68.5v-9.9h68.5z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m316.2 181.2h25.7v-9.9h-25.7z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m274.1 197.9h68.5v-9.9h-68.5z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m180.4 228.7h-68.5v-10h68.5z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m286.8 246h-174.9v-10h174.9z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m114.3 135.2h4.7v16.5h-4.7z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m137.9 135.2v16.5h-3.8l-7.2-8.8v8.8h-4.6v-16.5h3.8l7.3 8.8v-8.8z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m157.9 135.2l-7.1 16.5h-4.5l-7.1-16.5h5.1l4.4 10.7 4.6-10.7z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "d",
    d: "m157.8 143.5c0-5 3.9-8.6 9.1-8.6 5.3 0 9.2 3.6 9.2 8.6 0 4.9-3.9 8.5-9.2 8.5-5.2 0-9.1-3.6-9.1-8.5zm13.6 0c0-2.9-2-4.7-4.5-4.7-2.4 0-4.4 1.8-4.4 4.7 0 2.8 2 4.7 4.4 4.7 2.5 0 4.5-1.9 4.5-4.7z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m178.5 135.2h4.7v16.5h-4.7z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m185.7 143.5c0-5 3.8-8.6 9-8.6 3 0 5.5 1.1 7.1 3.1l-3 2.7c-1-1.3-2.3-1.9-3.9-1.9-2.7 0-4.5 1.8-4.5 4.7 0 2.8 1.8 4.7 4.5 4.7 1.6 0 2.9-0.7 3.9-2l3 2.7c-1.6 2-4.1 3.1-7.1 3.1-5.2 0-9-3.5-9-8.5z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m217.1 148.1v3.6h-13.2v-16.5h12.9v3.6h-8.3v2.8h7.3v3.5h-7.3v3z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m97.7 110.7c0 2.5-2 4.5-4.4 4.5-2.5 0-4.5-2-4.5-4.5 0-2.5 2-4.5 4.5-4.5 2.4 0 4.4 2 4.4 4.5z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m109.2 110.7c0 2.5-2 4.5-4.4 4.5-2.5 0-4.5-2-4.5-4.5 0-2.5 2-4.5 4.5-4.5 2.4 0 4.4 2 4.4 4.5z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m120.8 110.7c0 2.5-2 4.5-4.5 4.5-2.5 0-4.5-2-4.5-4.5 0-2.5 2-4.5 4.5-4.5 2.5 0 4.5 2 4.5 4.5z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m648.4 842.6l-261.5-1.1c-31.5-0.2-56.9-23.7-56.7-52.7l2.7-603.2c0.2-28.9 25.8-52.3 57.3-52.2q0 0 0.1 0l261.4 1.1c31.5 0.1 56.9 23.7 56.7 52.6l-2.7 603.3c-0.1 28.9-25.7 52.3-57.1 52.2q-0.1 0-0.2 0z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m649.5 151.3l-50.6-0.2-148.1-0.7h-17.8l-44.4-0.1c-22.1-0.1-40 16.5-40.1 37q0 0 0 0.1l-2.7 597.9c-0.1 20.5 17.7 37.3 39.7 37.4q0 0 0 0l261 1.1c22 0.1 40-16.5 40-37.1q0 0 0 0l2.7-598c0.1-20.5-17.6-37.3-39.7-37.4q0 0 0 0z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m651.9 204.5c0 1.8-1.5 3.2-3.3 3.2-1.8 0-3.3-1.4-3.3-3.2 0-1.8 1.5-3.3 3.3-3.3q0 0 0 0c1.8 0 3.3 1.5 3.3 3.3z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m651.8 216.3c0 1.8-1.4 3.2-3.2 3.2-1.9 0-3.3-1.5-3.3-3.3 0-1.8 1.5-3.2 3.3-3.2 1.8 0 3.2 1.5 3.2 3.3z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m651.8 228c0 1.8-1.5 3.2-3.3 3.3-1.8 0-3.3-1.5-3.3-3.3 0-1.8 1.5-3.3 3.3-3.3q0 0 0 0c1.8 0 3.3 1.5 3.3 3.3z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m586 218.3h-146.5c-2.9 0-5.3-2.4-5.3-5.3 0-2.9 2.4-5.3 5.3-5.3h146.5c2.9 0 5.3 2.4 5.3 5.3 0 2.9-2.4 5.3-5.3 5.3z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m590 741.6h-136.3c-16.3 0-29.5-13.2-29.5-29.5v-0.9c0-16.3 13.2-29.5 29.5-29.5h136.3c16.3 0 29.5 13.2 29.5 29.5v0.9c0 16.3-13.2 29.5-29.5 29.5z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "a",
    d: "m514.2 709c0 3.8-2.9 6.2-7.6 6.2h-3v4.5h-4.8v-17.1h7.8c4.7 0 7.6 2.5 7.6 6.4zm-4.9 0c0-1.6-1-2.6-3-2.6h-2.7v5h2.7c2 0 3-0.9 3-2.4z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "a",
    d: "m527.1 716.4h-7.2l-1.3 3.3h-5l7.6-17.1h4.7l7.6 17.1h-5zm-1.4-3.6l-2.2-5.4-2.2 5.4z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m542.9 713.6v6.1h-4.8v-6.2l-6.5-10.9h5.1l4 6.8 4.1-6.8h4.7z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m636.6 325.4h-252.5c-1.7 0-3.1-1.4-3.1-3.1v-0.1c0-1.7 1.4-3.1 3.1-3.1h252.5c1.7 0 3.1 1.4 3.1 3.1v0.1c0 1.7-1.4 3.1-3.1 3.1z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "m657 576.3c-8-22-11.8-45.4-11.8-68.9v-125.1c0-41.6-33.2-60-33.2-60h-228c0 0 33.1 18.4 33.1 60 0 41.7 0 146.9 0 146.9 0 0 1.5 92.8 47.5 102.3l220.7-0.3h21.8v-14.4c-13.4-10.1-43.2-21.6-50.1-40.5z"
  }))), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m666.5 565.3c-8-22-11.8-45.4-11.8-68.9v-125c0-41.7-39.4-49.1-39.4-49.1h-228c0 0 39.3 7.4 39.3 49.1 0 41.6 0 146.8 0 146.8 0 0 1.5 92.9 47.5 102.4l238.7-1.1c-23-4.7-37.5-30-46.3-54.2z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m666.5 565.3c0 0 0.6 1.6 1.8 4.6 1.2 3 3 7.5 5.9 13.1 2.8 5.6 6.7 12.4 12.6 19.5 3 3.4 6.5 7 10.8 10 4.3 3.1 9.4 5.6 15.3 6.8l2.4 0.5h-2.5c-54.3 0.3-137.7 0.7-238.7 1.2h-0.1c-9.5-2-18-8-24-15.9-6.1-7.9-10.4-17.1-13.7-26.8-3.3-9.7-5.6-19.9-7.3-30.3-1.6-10.4-2.8-21-2.9-31.8 0-43.1 0-88.3 0-134.7q0-5 0-10l-0.3-4.9-0.1-2.5c-0.1-0.8-0.3-1.6-0.5-2.4-0.9-6.4-3.4-12.6-6.9-18-3.6-5.4-8.3-9.9-13.7-13.4-5.3-3.5-11.3-6.1-17.4-7.5l-4.5-1h4.6c83.3 0 160.7 0 228 0h0.1c4.9 1.1 9.5 3 13.8 5.3 4.3 2.4 8.3 5.2 11.7 8.6 7 6.6 11.3 15.4 13 24.3 1.7 9 1 17.9 1.2 26.4q-0.1 12.8-0.1 24.9c0 32.1 0 60.1-0.1 83.1-0.2 23.1 3.2 41 6.2 52.9 1.5 5.9 2.9 10.4 3.9 13.5q0.7 2.2 1.1 3.4 0.4 1.1 0.4 1.1c0 0-0.6-1.5-1.7-4.5-1-3-2.4-7.5-4-13.5-3.1-11.9-6.5-29.8-6.4-52.9 0-23 0-51-0.1-83.1q0-12.1 0-24.9c-0.2-8.6 0.5-17.4-1.2-26.2-1.7-8.8-5.9-17.5-12.8-23.9-3.3-3.3-7.2-6.1-11.5-8.4-4.2-2.2-8.8-4.1-13.6-5.2h0.1c-67.3 0-144.7 0.1-228 0.1l0.1-1c6.3 1.4 12.3 4.1 17.8 7.6 5.5 3.6 10.3 8.2 14 13.7 3.6 5.5 6.2 11.9 7.1 18.5 0.1 0.8 0.3 1.6 0.4 2.4l0.2 2.5 0.3 5q0 5 0 10c0 46.4 0 91.6-0.1 134.7 0.2 10.7 1.3 21.3 2.9 31.7 1.7 10.3 3.9 20.4 7.2 30.1 3.3 9.6 7.5 18.8 13.6 26.5 5.9 7.8 14.2 13.6 23.4 15.6h-0.1c101-0.4 184.4-0.6 238.7-0.8v0.5c-5.9-1.2-11.1-3.8-15.5-6.9-4.3-3.1-7.8-6.7-10.8-10.2-5.9-7.1-9.8-14-12.6-19.6-2.8-5.7-4.5-10.2-5.8-13.2-1.1-3-1.6-4.6-1.6-4.6z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m720.7 619.5c16-11.7 26.4-30.7 27.6-50.5l-257.9-1c1.3 12 0 24.2-3.9 35.6-2.3 6.5-5.6 13-11.2 17z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m720.7 619.5q0 0-1.2 0.1-1.2 0-3.6 0c-3.1 0.1-7.8 0.1-13.8 0.2-12 0.1-29.5 0.2-51.4 0.3-43.9 0.3-105.2 0.6-175.4 1h-1.7l1.4-1c3.7-2.5 6.4-6.3 8.4-10.4 2-4.2 3.5-8.7 4.6-13.2 2.3-9.2 3-18.8 1.9-28.4v-0.6h0.5c2.4 0 5 0 7.6 0 103.2 0.5 194.6 0.9 250.3 1.2h0.3v0.3c-0.6 9.5-3.2 17.7-6.3 24.3-3.1 6.7-6.8 11.8-10.1 15.7-3.3 3.9-6.3 6.4-8.3 8.1-2.1 1.7-3.2 2.4-3.2 2.4q0 0 0.8-0.6 0.8-0.7 2.3-1.9c2-1.7 4.9-4.3 8.2-8.2 3.2-3.9 6.8-9 9.9-15.7 3-6.6 5.5-14.7 6.1-24.1l0.3 0.3c-55.7-0.1-147.1-0.4-250.3-0.7-2.6-0.1-5.2-0.1-7.6-0.1l0.6-0.6c1 9.8 0.3 19.6-2 28.8-1.1 4.7-2.6 9.2-4.6 13.4-2.1 4.2-5 8.2-8.8 10.9l-0.3-1c70.1-0.2 131.4-0.4 175.2-0.5 21.9 0 39.5-0.1 51.5-0.1 6.1 0 10.7 0 13.9 0.1q2.3 0 3.6 0 1.2 0 1.2 0z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m625 370.5c0 0.3-38.2 0.6-85.2 0.6-47 0-85.1-0.3-85.1-0.6 0-0.3 38.1-0.5 85.1-0.5 47 0 85.2 0.2 85.2 0.5z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m625 406.8c0 0.3-38.2 0.5-85.2 0.5-47 0-85.1-0.2-85.1-0.5 0-0.3 38.1-0.5 85.1-0.5 47 0 85.2 0.2 85.2 0.5z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m635.1 506.7c0 0.3-40.4 0.6-90.2 0.6-49.8 0-90.2-0.3-90.2-0.6 0-0.3 40.4-0.5 90.2-0.5 49.8 0 90.2 0.2 90.2 0.5z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "d",
    d: "m519.7 355.4c0 2.9-2.4 4.7-7 4.7h-9.2v-17.1h8.7c4.5 0 6.7 1.8 6.7 4.5 0 1.6-0.9 2.9-2.3 3.7 1.9 0.7 3.1 2.1 3.1 4.2zm-11.5-8.9v3.3h3.4q2.4 0 2.4-1.7c0-1-0.8-1.6-2.4-1.6zm6.5 8.4c0-1.2-0.8-1.8-2.5-1.8h-4v3.5h4c1.7 0 2.5-0.6 2.5-1.7z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m522.2 343h4.8v17.1h-4.8z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m530.5 343h4.8v13.2h8.2v3.9h-13z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m545.4 343h4.8v13.2h8.1v3.9h-12.9z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m543.4 396.5h-86.5v-12.9h86.5z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m629.3 396.5h-51.3v-12.9h51.3z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m539.8 435.7h-82.9v-13h82.9z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m491.6 463.3h-34.7v-12.9h34.7z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m513.1 488.9h-56.2v-12.9h56.2z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m638.7 559.6h-175.2v-12.9h175.2z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m630.7 435.7h-25.2v-13h25.2z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m630.7 460.4h-25.2v-12.9h25.2z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m630.7 487.9h-25.2v-12.9h25.2z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m630.3 531.2h-34.9v-12.9h34.9z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "m707.6 261.9l-161.7-2.4c-8.8 0-15.9-7.1-15.9-15.9v-109.4h118.2c31.5 0 60.2 20.2 60.2 57z"
  }))), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m554 69.7h260.3c4.6 0 8.3 3.7 8.3 8.3v159c0 4.6-3.7 8.3-8.3 8.3h-260.3c-4.5 0-8.2-3.7-8.2-8.3v-159c0-4.6 3.7-8.3 8.2-8.3z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "a",
    d: "m591.4 109.8c0 2.3-1.8 3.6-5.2 3.6h-6.7v-13h6.3c3.2 0 4.9 1.3 4.9 3.3 0 1.3-0.6 2.4-1.7 2.9 1.4 0.4 2.4 1.7 2.4 3.2zm-9-7.2v3.1h3c1.5 0 2.3-0.5 2.3-1.5 0-1-0.8-1.6-2.3-1.6zm6 6.9c0-1.1-0.9-1.6-2.5-1.6h-3.5v3.2h3.5c1.6 0 2.5-0.5 2.5-1.6z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "a",
    d: "m602.2 110.6h-6l-1.2 2.8h-3.1l5.8-13h3l5.7 13h-3.1zm-1-2.3l-2-5-2.1 5z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m619.8 100.4v13h-2.5l-6.5-7.9v7.9h-3v-13h2.5l6.5 7.9v-7.9z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m627.6 108.3l-1.8 1.9v3.3h-2.9v-13h3v6l5.8-6h3.3l-5.4 5.7 5.8 7.2h-3.5z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m588.9 163.8h-2.4v3.2h-1.2v-3.2h-6.7v-0.8l6.3-8h1.4l-6.1 7.7h5.2v-2.7h1.1v2.7h2.4z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m597.7 163.6c0 1.9-1.5 3.5-4.3 3.5-1.6 0-3.1-0.5-4.3-1.5l0.6-1c1 0.9 2.3 1.4 3.7 1.4 1.9 0 3-1 3-2.4 0-1.5-1-2.4-3.2-2.4h-0.8v-0.9l3.3-4.2h-6.1v-1.1h7.6v0.9l-3.3 4.3c2.5 0.2 3.8 1.5 3.8 3.4z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m607.3 163.5c0 2-1.4 3.6-4.3 3.6-1.6 0-3.1-0.5-4.3-1.5l0.6-1c1 0.9 2.3 1.4 3.7 1.4 2 0 3.1-1 3.1-2.5 0-1.4-1-2.5-4-2.5h-2.5l0.6-6h6.5v1.1h-5.4l-0.5 3.9h1.6c3.6-0.1 4.9 1.4 4.9 3.5z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "a",
    d: "m617.9 163.4c-0.1 2.1-1.8 3.7-3.8 3.7q-0.2 0-0.3 0c-3.2 0-4.9-2.2-4.9-6 0-4 2.2-6.1 5.4-6.1 1-0.1 2 0.1 2.9 0.6l-0.5 1c-0.7-0.4-1.5-0.6-2.3-0.6-2.6 0-4.3 1.7-4.3 4.9q0 0.4 0 1c0.7-1.4 2.2-2.1 3.7-2 2-0.3 3.8 1.1 4 3.1q0.1 0.2 0.1 0.4zm-1.3 0c0-1.6-1.1-2.6-3-2.6-1.5-0.1-2.8 1-3 2.5q0 0.1 0 0.1c0 1.4 1.1 2.6 3.1 2.6 1.5 0.2 2.8-0.8 2.9-2.3q0-0.1 0-0.2z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m643.6 167l-2.8-3.8-2.9 3.8h-1.4l3.6-4.6-3.4-4.4h1.4l2.7 3.5 2.7-3.5h1.3l-3.4 4.3 3.6 4.6z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m652.7 167l-2.9-3.8-2.8 3.8h-1.4l3.5-4.6-3.3-4.4h1.3l2.7 3.5 2.7-3.5h1.3l-3.3 4.3 3.6 4.6z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m661.8 167l-2.8-3.8-2.9 3.8h-1.3l3.5-4.6-3.4-4.4h1.4l2.7 3.5 2.7-3.5h1.3l-3.4 4.3 3.6 4.6z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m670.9 167l-2.8-3.8-2.9 3.8h-1.4l3.6-4.6-3.4-4.4h1.4l2.6 3.5 2.7-3.5h1.4l-3.4 4.3 3.6 4.6z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m702.3 167l-2.8-3.8-2.9 3.8h-1.3l3.5-4.7-3.4-4.3h1.4l2.7 3.5 2.7-3.5h1.4l-3.5 4.3 3.6 4.6z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m711.4 167l-2.8-3.8-2.9 3.8h-1.4l3.6-4.6-3.4-4.4h1.4l2.7 3.5 2.7-3.5h1.3l-3.4 4.3 3.6 4.6z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m720.5 167l-2.8-3.8-2.9 3.8h-1.3l3.5-4.7-3.3-4.3h1.3l2.7 3.5 2.7-3.5h1.3l-3.4 4.3 3.6 4.6z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m729.6 167l-2.8-3.8-2.9 3.8h-1.3l3.5-4.6-3.3-4.4h1.4l2.7 3.5 2.7-3.5h1.3l-3.5 4.3 3.6 4.6z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m757.8 155v12h-1.2v-10.9h-2.8v-1.1z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m768.6 163.6c0 1.9-1.5 3.5-4.4 3.5-1.5 0-3.1-0.5-4.3-1.5l0.6-1c1 0.9 2.4 1.4 3.7 1.4 2 0 3.1-1 3.1-2.4 0-1.5-1-2.4-3.2-2.4h-0.9v-0.9l3.3-4.2h-6.1v-1.1h7.7v0.9l-3.3 4.3c2.5 0.2 3.8 1.5 3.8 3.4z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m780.4 163.8h-2.4v3.2h-1.2v-3.2h-6.7v-0.8l6.3-8h1.4l-6.1 7.7h5.1v-2.7h1.2v2.7h2.4z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m789.6 165.9v1.1h-8.3v-0.8l4.9-4.9c1.4-1.3 1.6-2.1 1.6-2.9 0-1.4-1-2.3-2.8-2.3-1.2 0-2.4 0.5-3.2 1.4l-0.9-0.8c1.1-1.1 2.6-1.8 4.2-1.7 2.4 0 4 1.2 4 3.2-0.1 1.5-0.8 2.9-2 3.8l-4 4z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m572.5 191.7c0-1.6 1.3-2.9 2.9-2.9q0.1 0 0.2 0c0.8 0 1.7 0.3 2.3 1l-0.9 0.8c-0.3-0.4-0.8-0.7-1.4-0.7-1 0-1.8 0.8-1.8 1.8 0 1 0.8 1.9 1.8 1.9q0 0 0 0c0.6 0 1.1-0.3 1.4-0.7l0.9 0.8c-0.6 0.6-1.5 1-2.4 1-1.6 0.1-2.9-1.2-3-2.8q0-0.1 0-0.2z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "a",
    d: "m582.4 193.4h-2.6l-0.5 1.2h-1.4l2.6-5.8h1.3l2.5 5.8h-1.4zm-0.4-1l-0.9-2.2-0.9 2.2z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "a",
    d: "m588.5 194.6l-1.1-1.6h-1.2v1.6h-1.3v-5.8h2.5c1.5 0 2.5 0.8 2.5 2.1 0 0.8-0.5 1.5-1.2 1.8l1.2 1.8zm-1.2-4.6h-1.1v1.9h1.1c0.8 0 1.2-0.4 1.2-1q0-0.9-1.2-0.9z"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m590.4 194l0.5-1c0.6 0.4 1.2 0.6 1.9 0.6 0.8 0 1.1-0.2 1.1-0.6 0-1.1-3.3-0.3-3.3-2.4 0-1 0.8-1.8 2.4-1.8 0.7 0 1.3 0.2 1.9 0.5l-0.4 1q-0.7-0.4-1.6-0.4c-0.7 0-1.1 0.2-1.1 0.6 0 1 3.4 0.3 3.4 2.4 0 1-0.8 1.8-2.4 1.8-0.9 0-1.7-0.2-2.4-0.7z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m603.7 188.9v5.8h-1.3v-2.4h-2.6v2.4h-1.3v-5.8h1.3v2.2h2.6v-2.2z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "a",
    d: "m604.6 191.7c-0.1-1.7 1.2-3.1 3-3.2 1.7-0.1 3.1 1.2 3.2 2.9 0.1 1.7-1.2 3.2-2.9 3.3q-0.1 0-0.2 0c-1.6 0.1-3-1.2-3.1-2.8q0-0.1 0-0.2zm4.9 0c0-1-0.8-1.7-1.8-1.7-1 0-1.8 0.8-1.8 1.8 0.1 1 0.9 1.8 1.8 1.8 1 0 1.8-0.8 1.8-1.8q0 0 0-0.1z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m611.8 188.9h1.4v4.6h2.8v1.1h-4.2z"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "a",
    d: "m616.8 188.9h2.6c1.5 0 2.8 1.3 2.8 2.9 0 1.6-1.3 2.9-2.8 2.9h-2.6zm2.5 4.6c1 0 1.8-0.8 1.8-1.8 0-1-0.8-1.8-1.8-1.8q0 0 0 0h-1.2v3.6z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m627.9 193.5v1.1h-4.4v-5.8h4.3v1.1h-3v1.2h2.7v1.1h-2.7v1.3z"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "a",
    d: "m632.5 194.6l-1.1-1.6h-1.2v1.6h-1.3v-5.8h2.5c1.5 0 2.4 0.8 2.4 2.1 0.1 0.8-0.4 1.5-1.1 1.8l1.2 1.8zm-2.3-4.6v1.9h1.1c0.8 0 1.2-0.4 1.2-1 0-0.6-0.4-0.9-1.2-0.9z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m574.2 208.7h78.3c1.7 0 3.1 1.4 3.1 3.1v1.2c0 1.7-1.4 3-3.1 3h-78.3c-1.7 0-3-1.3-3-3v-1.2c0-1.7 1.3-3.1 3-3.1z"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m751.3 208.7h40.8c1.7 0 3 1.4 3 3.1v1.2c0 1.7-1.3 3-3 3h-40.8c-1.7 0-3.1-1.3-3.1-3v-1.2c0-1.7 1.4-3.1 3.1-3.1z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m813.4 69.7h-258.4c-5.1 0-9.2 4.1-9.2 9.2v46.3c16.3 11.4 38.8 13.5 58.6 9.3 23.5-4.9 44.7-16.9 66.6-26.8 21.8-9.8 45.8-17.7 69.5-13.6 22.3 3.8 41.3 17.7 61.4 28 6.6 3.4 13.6 6.2 20.7 8.3v-51.5c0-5.1-4.1-9.2-9.2-9.2z"
  }))), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m761.8 94h13.5c3.4 0 6.1 2.8 6.1 6.1v13.5c0 3.4-2.7 6.1-6.1 6.1h-13.5c-3.3 0-6.1-2.7-6.1-6.1v-13.5c0-3.3 2.8-6.1 6.1-6.1z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m169 904.5h-13.6l-16.4-96.2h20z"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m41.7 904.5h13.6l16.5-96.2h-20z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m397.9 904.5h-13.7l-16.4-96.2h20z"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m270.6 904.5h13.6l16.4-96.2h-20z"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m398.3 810.4h-369.3v-40.6h369.3z"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m357.4 749.3h-228.8c-9.9 0-17.9-8-17.9-17.9v-20.7c0-9.9 8-17.9 17.9-17.9h228.8c9.9 0 17.9 8 17.9 17.9v20.7c0 9.9-8 17.9-17.9 17.9z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m407.1 770.8h-111.8v-110.2h92.2c10.8 0 19.6 8.8 19.6 19.6z"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m325.8 692.8h-204v-149.8h177.8c14.5 0 26.2 11.8 26.2 26.2z"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m367.3 771.5l-228.3 0.2v-25.4h228.3z"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m264.4 692.8h-235.4v-139.5c0-5.7 4.6-10.3 10.3-10.3h225.1z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "m71.4 692.8h-26.7c-8.7 0-15.7-7-15.7-15.6v-124c0-5.6 4.6-10.2 10.2-10.2h47.9v134.2c0 8.6-7 15.6-15.7 15.6z"
  }))), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m190.1 491.5l-11.4-63.4c-3-19.3 5.7-37.1 25-39.5l1.8-0.1c18.1-1.3 34.1 11.6 36.8 29.5 2.5 16.7 5.1 35.2 5.6 44.2 1 18.7-17.4 22.8-17.4 22.8-0.1 0 1.1 11.3 1.7 16.8l-3.1 14.4z"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m230.4 485.1c0 0-11.7 1.5-24.7-5.5 0 0 6.8 13.6 25.3 10.6z"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m237.7 435.4c0.1 1.4-0.9 2.7-2.4 2.8-1.4 0.2-2.7-0.8-2.9-2.2-0.1-1.4 0.9-2.7 2.4-2.8 1.4-0.2 2.8 0.8 2.9 2.2z"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m238.8 425.9c-0.3 0.4-2.4-1-5.2-0.8-2.9 0.2-4.9 1.8-5.2 1.5-0.2-0.2 0.1-0.8 1-1.6 0.8-0.7 2.3-1.4 4.1-1.6 1.8-0.1 3.3 0.5 4.2 1.1 1 0.6 1.3 1.2 1.1 1.4z"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m212.7 437.3c0.2 1.4-0.9 2.7-2.4 2.9-1.4 0.2-2.7-0.8-2.9-2.2-0.1-1.4 1-2.7 2.4-2.9 1.5-0.2 2.8 0.8 2.9 2.2z"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m210.8 428.5c-0.3 0.3-2.4-1-5.3-0.8-2.8 0.2-4.8 1.8-5.2 1.4-0.1-0.1 0.2-0.8 1-1.5 0.9-0.7 2.4-1.5 4.2-1.6 1.7-0.1 3.3 0.5 4.2 1.1 0.9 0.6 1.3 1.2 1.1 1.4z"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m222.6 449.8c0-0.2 1.7-0.6 4.6-1.2 0.7-0.1 1.4-0.3 1.5-0.8 0.1-0.5-0.2-1.3-0.7-2.1q-1.2-2.6-2.5-5.5c-3.5-7.7-6.2-14.1-5.8-14.2 0.3-0.1 3.4 6 6.9 13.7q1.3 2.9 2.5 5.5c0.3 0.8 0.9 1.7 0.6 2.8-0.2 0.6-0.7 1-1.2 1.2-0.4 0.2-0.8 0.2-1.2 0.3-2.9 0.3-4.7 0.4-4.7 0.3z"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m211.1 419.4c-0.3 0.8-3.1 0.2-6.5 0.4-3.4 0.1-6.2 0.9-6.6 0.1-0.2-0.3 0.4-1 1.5-1.7 1.1-0.7 2.9-1.3 5-1.3 2-0.1 3.8 0.4 5 0.9 1.2 0.6 1.8 1.3 1.6 1.6z"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m238.4 417.5c-0.5 0.7-2.9 0.2-5.7 0.4-2.8 0.1-5.2 0.8-5.8 0.2-0.2-0.3 0.1-1 1.1-1.7 0.9-0.7 2.6-1.3 4.5-1.4 2-0.1 3.7 0.3 4.7 0.9 1.1 0.6 1.4 1.2 1.2 1.6z"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m181.1 441.1c-0.3-0.1-13.1-2.9-11.8 9.8 1.3 12.7 16 9.2 16 9.2 0-0.4-4.2-19-4.2-19z"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m178.7 454.9c-0.1 0-0.2 0.2-0.6 0.4-0.3 0.2-0.9 0.4-1.6 0.2-1.4-0.3-2.8-2.4-3.1-4.6-0.1-1.2 0-2.3 0.3-3.3 0.3-0.9 0.9-1.7 1.5-1.8 0.7-0.3 1.2 0.1 1.4 0.4 0.2 0.4 0.2 0.6 0.2 0.6 0.1 0.1 0.3-0.2 0.1-0.7 0-0.3-0.2-0.5-0.6-0.8-0.3-0.2-0.7-0.3-1.2-0.2-1 0.2-1.8 1.2-2.1 2.2-0.4 1.1-0.6 2.4-0.4 3.7 0.3 2.5 1.9 4.8 3.7 5.1 1 0.2 1.7-0.2 2-0.5 0.4-0.4 0.4-0.6 0.4-0.7z"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m266 397.9c-0.2-0.8-0.8-1.3-1.5-1.7-1.6-0.7-3.2-0.4-4.9-0.3-4 0.4-8.1-0.3-11.9-1.7 1.2-0.8 2.3-1.7 3.2-2.8 1.8-2.2 2.7-5.5 1.5-8.1-0.2-0.5-0.6-1.1-1.1-1.2-0.9-0.1-1.5 0.7-2 1.4-1.7 2.4-3.4 3.4-6.2 3.4-1.8 0-3.5-0.2-5-0.9q-0.1-0.1-0.2-0.2-1.1-0.9-2.1-1.8 0 0 0 0c-5.3-4.2-9.7-7.1-14.1-8.4-6.5-1.9-16.9-1.9-23.3 0.4-6.3 2.4-11.6 8.2-11.8 14.9-3.9-2.7-9.4-2.1-13.6 0.1l-0.1-0.1c-4.8 2.3-7.1 7.8-8 12.9q-0.1 0.5-0.2 0.9c-1.4 2.8-3.4 5.3-6 7.1-0.4 0.3-0.9 0.7-0.9 1.3 0 0.5 0.5 0.9 0.9 1.2 1.3 0.7 2.7 1.2 4.2 1.3q-0.5 1.8-1.3 3.6c-0.5 1-1 2.2-0.4 3.1 0.4 0.7 1.4 0.9 2.2 0.7 0.8-0.2 1.5-0.7 2.2-1.2q-0.6 2-1.2 4.1c1.8 0.1 3.6-0.2 5.3-0.9 1.5 4.6 3.1 13.2 4.6 16.3 3.4-0.3 4.2-0.7 6-0.3 2.2 0.5 1.8 4.5 4.5 3.1 1.5-0.7 3.1-6.5 3.5-8 2.3-10.2 2.3-20.9 0.1-31.1 1.8-2.4 4.1-4.4 6.7-5.9l-0.2 0.2c5-2.3 10.7-4.6 15.9-2.7 4 1.5 6.7 5.3 9.8 8.2 6.1 5.4 12.5 8 20.6 7.6 1.3 5.5 2.4 14.7 3.2 19.9l3.5-10.9q0.4-0.9 0.7-1.9l0.1-0.2c0.4-1.1 0.7-2.1 1.2-3.2q0 0.1 0 0.1c3.1 2.2 6.9-2 4.4-4.9q-0.8-0.8-1.7-1.4c1.4 1.1 3.4 1.5 5 0.8 1.7-0.7 2.8-2.6 2.5-4.3-0.2-1.2-1.2-2.2-2.3-2.6 2.3 0 4.6-0.8 6.5-2.1 1.2-0.9 2.4-2.2 1.7-3.8z"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m192.7 392.5c0 0-0.8 0.6-1.7 1.9-1 1.3-2 3.5-2.3 6.4-0.1 1.5-0.2 3.1 0 4.8 0.2 1.7 0.5 3.5 0.8 5.5 0.3 1.9 0.7 3.9 0.7 6.1q0.1 1.6-0.1 3.2c-0.1 1.1-0.3 2.3-1 3.3-0.5 0.8-1.6 1.2-2.5 1.1-0.9-0.1-1.8-0.5-2.5-1.1-1.3-1.3-1.8-3-2.3-4.5h0.4c-0.5 1.4-1 2.9-1.8 4.1-0.9 1.2-2.1 2.1-3.5 2.3-0.6 0.1-1.3 0.1-1.9-0.1-0.6-0.3-1.1-0.7-1.5-1.2-0.3-0.5-0.5-1-0.5-1.6 0-0.6 0.1-1.1 0.4-1.5l0.3 0.2c-1.3 1.7-2.7 2.8-3.7 3.3q-0.8 0.5-1.2 0.6-0.5 0.2-0.5 0.2 0 0 0.4-0.2 0.4-0.2 1.2-0.7c0.9-0.6 2.3-1.6 3.5-3.4l0.3 0.2c-0.6 0.7-0.5 1.8 0.1 2.7 0.3 0.5 0.8 0.9 1.3 1.1 0.5 0.2 1.2 0.2 1.8 0.1 1.2-0.3 2.4-1.1 3.1-2.2 0.9-1.2 1.4-2.6 1.8-4.1l0.3-0.6 0.1 0.6c0.5 1.6 1 3.2 2.2 4.4 0.6 0.5 1.4 0.9 2.2 1 0.9 0.1 1.7-0.3 2.2-1 0.6-0.8 0.8-2 0.9-3q0.2-1.6 0.1-3.2c-0.1-2.1-0.4-4.1-0.7-6.1-0.3-1.9-0.6-3.7-0.8-5.5-0.1-1.7-0.1-3.3 0.1-4.8 0.3-3 1.4-5.2 2.4-6.5 1.1-1.3 1.9-1.8 1.9-1.8z"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m252 404.9q0 0-0.1 0.2-0.2 0.1-0.4 0.4-0.3 0.2-0.8 0.5c-0.3 0.3-0.6 0.5-1.1 0.7-1.6 1-4.3 2.1-7.8 2.3-3.4 0.1-7.7-0.7-11.6-3.1-4-2.3-7.7-5.9-10.8-10.2-1.5-2.1-2.9-4.3-4.3-6.3-1.4-2-2.9-3.8-4.7-5.2-1.8-1.5-3.7-2.4-5.7-2.8-1-0.2-1.9-0.1-2.9 0q-1.3 0.2-2.5 0.7c-1.6 0.7-2.8 1.7-3.7 2.7-0.8 1.1-1.4 2.1-1.8 3-0.7 1.8-0.6 2.9-0.7 2.9q0 0 0-0.2 0-0.3 0.1-0.6c0-0.5 0.1-1.3 0.5-2.2 0.3-0.9 0.9-2 1.8-3 0.9-1.1 2.1-2.1 3.7-2.9 0.8-0.3 1.6-0.6 2.6-0.8 0.9-0.1 1.9-0.1 3 0.1 2 0.3 4 1.3 5.8 2.7 1.9 1.5 3.4 3.3 4.9 5.4 1.4 2 2.7 4.2 4.3 6.3 3.1 4.2 6.7 7.8 10.6 10.1 3.9 2.3 8 3.2 11.4 3.1 3.4-0.1 6.1-1.2 7.8-2.1 1.6-0.9 2.4-1.7 2.4-1.7z"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m252.9 396.6q0 0-0.6 0.5c-0.4 0.3-1.1 0.8-1.9 1.2-0.8 0.5-1.8 0.9-3 1.3-1.2 0.4-2.5 0.8-4 1-1.4 0.2-2.8 0.2-4 0.1-1.3-0.1-2.4-0.3-3.3-0.5-0.9-0.2-1.6-0.5-2.1-0.7q-0.8-0.3-0.7-0.3c0-0.1 1.1 0.3 2.9 0.7 0.9 0.2 2 0.3 3.2 0.4 1.2 0 2.6 0 4-0.2 1.4-0.2 2.7-0.5 3.9-0.8 1.1-0.4 2.1-0.8 3-1.3 1.6-0.8 2.6-1.5 2.6-1.4z"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m223.3 458.5c-0.2-0.5-3.1 1-6.4-0.4-3.3-1.4-4.6-4.6-5-4.4-0.2 0.1-0.2 1 0.4 2.3 0.6 1.3 2 2.9 4 3.8 2.1 0.8 4.1 0.6 5.3 0.1 1.3-0.5 1.8-1.2 1.7-1.4z"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m400.8 731.9l24.6 32.8c0 0 41.7-13.9 46.8-8.3l-61.9 50-40.5-49.6z"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m404.1 777.5c-0.9 1.3-0.7 3.3 0.6 4.3 1.3 1 3.3 0.8 4.3-0.5 0.9-1.3 0.7-3.7-0.7-4.6-1.3-0.8-3.7-0.4-4.3 1.1"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m410.3 806.4l-3.9-5.2 60.8-46c0 0 3.8-1 5 1.2z"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m426.2 763.6c0.2 0.3-1.2 1.7-1.9 3.9-0.7 2.1-0.4 4.1-0.8 4.2-0.3 0.1-1.4-2.1-0.5-4.7 0.9-2.6 3-3.7 3.2-3.4z"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m434.9 761.1c0.3 0.2-0.6 1.8-0.6 3.9-0.1 2.1 0.8 3.7 0.5 3.9-0.3 0.3-1.9-1.3-1.9-3.9 0-2.7 1.7-4.2 2-3.9z"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m444.8 765.9c-0.2 0.3-1.8-0.9-2.4-3.2-0.6-2.3 0.3-4.1 0.7-3.9 0.3 0.1 0.1 1.7 0.6 3.6 0.5 1.9 1.4 3.2 1.1 3.5z"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m419.8 756.8c0.1 0.3-1.7 1-3.3 2.5-1.6 1.5-2.5 3.1-2.9 3-0.3-0.1 0.1-2.2 2-4 1.9-1.7 4.1-1.9 4.2-1.5z"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m345.6 843.9l-1.6 41c0 0 41.2 15.3 41.6 22.9l-79.6-0.1-0.2-64z"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m319.4 881.4c-1.5 0.4-2.6 2.1-2.2 3.7 0.3 1.5 2.1 2.6 3.6 2.3 1.6-0.4 2.9-2.5 2.4-4-0.5-1.5-2.7-2.7-4.1-1.9"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m306 907.7l0.3-6.5 76.2 2.6c0 0 3.5 1.6 3.1 4z"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m345.3 884.5c0 0.4-1.9 0.5-3.9 1.8-1.9 1.2-2.9 2.9-3.2 2.7-0.4-0.1 0.2-2.4 2.5-3.9 2.4-1.4 4.7-1 4.6-0.6z"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m353.7 888c0.1 0.3-1.6 1-3 2.6-1.3 1.6-1.7 3.4-2.1 3.4-0.3 0.1-0.6-2.2 1.1-4.2 1.7-2.1 4-2.2 4-1.8z"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m358.4 898c-0.4 0-0.9-1.9 0.1-4 1-2.2 2.8-3 3-2.7 0.2 0.3-1 1.5-1.8 3.2-0.8 1.8-0.9 3.4-1.3 3.5z"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m344.6 875.1c-0.1 0.4-1.9-0.2-4.1 0-2.2 0.1-3.9 0.8-4.1 0.5-0.2-0.3 1.4-1.8 4-1.9 2.6-0.1 4.4 1.1 4.2 1.4z"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m183.8 664.1c1-0.4 37.3-16.2 67-28.5 19.8-8.2 44.5-12.5 44.5-12.5 0 0 30.2-17.6 41.7-1.6 11.5 16 93 127.5 92.4 129.2-0.6 1.8-39.5 36.3-39.5 36.3 0 0-84-106.8-85.7-106.3-1.7 0.6-40.5 31-40.5 31 0 0-11.7 12-20.3 13.2-8.6 1.1-58.9-2.9-58.9-2.9l-19.1-51.6z"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m226.6 709.1c1.8 1.2 20.9 14.6 20.9 14.6l43.3 10 8.8 142.1 51.7-1.9c0 0 0.1-102.4 0.1-126.4 0-24-0.6-46.2-7.8-54-7.2-7.8-39.4-12.8-39.4-12.8z"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m351.3 742q0-0.1-0.1-1.7 0-1.8 0-4.8c-0.1-4.2-0.2-10.3-0.7-17.8-0.3-3.7-0.7-7.8-1.4-12.1q-0.3-1.6-0.6-3.3c-0.3-1-0.5-2.2-0.9-3.3-0.7-2.2-1.6-4.3-3.4-5.9-3.7-3.1-8.6-5.1-13.6-6.8-5.1-1.7-10.5-3.2-16.1-4.4-2.9-0.7-5.8-1.2-8.5-1.7l0.4-0.1c-16.4 12.8-30.9 24.1-41.5 32.4-5.2 4-9.4 7.2-12.4 9.6q-2.1 1.6-3.4 2.5-1.2 0.9-1.2 0.8 0 0 1.1-1 1.2-1 3.3-2.6c2.9-2.4 7.1-5.8 12.2-9.9 10.5-8.3 25-19.8 41.3-32.7l0.1-0.1h0.3c2.7 0.5 5.6 1.1 8.6 1.7 5.6 1.3 11 2.7 16.1 4.5 5.1 1.8 10 3.7 14 7 1.9 1.8 2.9 4.2 3.7 6.5 0.3 1.1 0.5 2.2 0.8 3.3q0.3 1.7 0.6 3.4c0.7 4.4 1 8.5 1.3 12.2 0.4 7.5 0.4 13.6 0.3 17.8q-0.1 3.1-0.1 4.8-0.1 1.6-0.2 1.7z"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m184.6 494.2l3.1-16 34.9 19.6 8.1-10.5 0.8 3.3 34.7 59.1 22.1 71.5-94.8 38.7-10.3-58.3z"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m257.7 613.3q-0.1 0-0.3-1.1-0.2-1.4-0.5-3.4c-0.5-2.9-1.1-7.2-2.1-12.4-1.9-10.4-5-24.8-9.8-40.2-4.8-15.5-10.2-29.1-14.6-38.8-2.1-4.8-3.9-8.7-5.2-11.4q-0.9-1.9-1.5-3.1-0.5-1-0.4-1.1 0 0 0.6 1 0.6 1.2 1.6 3c1.4 2.6 3.4 6.5 5.6 11.3 4.5 9.6 10.2 23.2 15 38.8 4.7 15.5 7.8 29.9 9.5 40.4 0.8 5.2 1.4 9.5 1.7 12.4q0.2 2.1 0.3 3.4 0.1 1.2 0.1 1.2z"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m236.2 501.3c0 0-0.4 0.6-1.2 1.7q-1.5 1.8-3.6 4.4l-0.3 0.3-0.2-0.2c-2.5-2.2-5.4-4.8-8.8-7.8l0.9-0.2c-1 3.4-2.1 7.2-3.2 11.1l-0.2 0.6-0.6-0.2q-1.2-0.6-2.5-1.3c-8.4-4.1-15.9-7.9-21.4-10.7q-3.8-2-6.4-3.4c-1.5-0.8-2.3-1.3-2.3-1.4 0.1 0 0.9 0.3 2.5 1q2.6 1.2 6.6 3.1c5.5 2.6 13.1 6.3 21.5 10.4q1.3 0.7 2.5 1.3l-0.8 0.3c1.2-3.9 2.3-7.6 3.3-11.1l0.2-0.7 0.6 0.5c3.3 3 6.1 5.7 8.5 7.9l-0.5 0.1q2.3-2.6 3.9-4.3c0.9-1 1.4-1.5 1.5-1.4z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "m184.5 722l9 0.7 13.1-68.4c0 0-14.3 8.7-14.6 9.8-0.4 1.1-7.5 57.9-7.5 57.9z"
  }))), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m186.4 484.8l-5.5 10.2-29.9 16.1 9.8 110.6c0 0-19 54-19 77.8 0 23.9 5.3 35.4 11.5 38.5 6.2 3.1 30.1-8.4 30.1-8.4 0 0 2.6-14.1 16.4-46 13.9-31.9 28.7-66.8 28.7-66.8 0 0 4.4-17.2-5.7-48.6-10.2-31.4-36.4-83.4-36.4-83.4z"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m327 533.6c0 0-0.7-16.7 0.2-19.5q0 0 0-0.1c1.4-4.1 6.2-8.5 10.5-9.2 2.3-0.5 4.1-0.3 4.9 0.4 0.8 0.8 1.9 7.1 1.9 7.1l22.3-4.2c0 0-13.2 20.6-16.9 26.1-3.7 5.5-7.5 9.1-7.5 9.1l-24.6 58.6-10-33.4z"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m375.8 473.2c-5.5 10.6-24.2 46.9-29.6 57.3-0.8 1.5-2.7 2.2-4.3 1.5-1.7-0.8-2.4-2.9-1.6-4.6l29.5-57.3c0.9-1.7 3-2.4 4.6-1.5 1.6 0.9 2.3 2.9 1.4 4.6z"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m368.3 488.4c0.5 0.1 2.7-0.5 3 2 0.3 2.5-0.1 11.2-1.3 11.7-1.3 0.6-3.2 1.5-3.2 1.5 0 0 1.2 5.4-0.1 7.3-1.3 1.9-3.7 3.2-3.7 3.2 0 0-0.1 4.5-1.5 6.2-1.3 1.8-4.5 4.7-4.5 4.7 0 0-0.8 7.2-4.2 8.6-3.4 1.3-4.1 2.4-4.1 2.4l-1.1-4.4c0 0-9.1-6.3-11-7.4-1.8-1.2-2.7-3.8-0.9-4.9 1.8-1.2 13.7 4.9 13.7 4.9l4.3-4.4-2.6-4.9c0 0-5.2-5.7-5.1-6.9 0.1-1.2 2.4-3.2 4.4-3 2.1 0.2 7.3 4.8 7.3 4.8 0.4 1 1.8 1.1 2.3 0.1l0.3-0.6c0 0-1.8-5.6-2.8-9.8-0.2-1.1 0.1-3.1 1.2-3.5 2.2-1 4-1.1 5.2 1z"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m332.8 512.4c0 0.1 1 0.1 2.6 0.1l-0.3-0.2c0.3 1.1 0.5 2.5 1.5 4 0.4 0.7 1.2 1.4 2.1 1.8 0.9 0.4 2.1 0.5 3.1-0.1 0.9-0.5 1.4-1.4 1.7-2.2 0.3-0.8 0.4-1.6 0.4-2.3 0.2-1.5 0.2-2.8 0-3.9-0.3-2.3-0.8-3.6-1-3.5-0.1 0 0.2 1.4 0.3 3.5 0 1.1 0 2.4-0.2 3.8-0.2 1.3-0.5 3.1-1.7 3.7-0.6 0.4-1.5 0.4-2.2 0.1-0.8-0.3-1.4-0.8-1.8-1.4-0.9-1.3-1.2-2.6-1.6-3.7l-0.1-0.2h-0.2c-1.7 0.2-2.6 0.3-2.6 0.5z"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m347.6 531.6c0.1-0.1-1.4-1.3-3.9-3.1q-2.1-1.4-4.5-3.1-1.2-0.9-2.6-1.8c-0.7-0.6-1.5-1.6-1.6-2.5-0.1-0.9 0.8-1.5 1.7-1.4 1 0.1 2.1 0.4 3 0.7 1.9 0.6 3.6 1.3 5 1.9 2.9 1.2 4.6 2 4.7 1.9 0-0.1-1.6-1.2-4.4-2.5-1.4-0.7-3-1.5-5-2.2-1-0.4-2-0.7-3.2-0.8-0.6-0.1-1.4 0.1-1.9 0.5-0.6 0.4-1 1.3-0.9 2 0.2 1.4 1.1 2.4 2 3.2q1.4 0.9 2.7 1.8 2.5 1.5 4.6 2.9c2.6 1.7 4.2 2.6 4.3 2.5z"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m361.7 516.1c0.3-0.1 0.1-1.9-1.1-3.8-1.2-1.9-2.8-2.9-2.9-2.6-0.2 0.2 0.9 1.4 2 3.1 1.1 1.8 1.7 3.3 2 3.3z"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m363.1 496c-0.2 0.2 0.6 2 1.8 4.1 1.2 2.1 1.8 3.9 2.1 3.8 0.3 0 0-2.1-1.2-4.3-1.2-2.2-2.4-3.7-2.7-3.6z"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m318.3 547.7c-0.8 1.3-14 24.2-14 24.2 0 0-30.2-68.9-40.6-70-10.8-1.2-2.5 29.8-2.5 29.8l26 79.1c0 0 18.2 5.7 28.3-1 10.2-6.6 33.1-52.3 33.1-52.3z"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m231.5 490.1c0 0 25 48.8 32.2 74.7 4.7 17 11.3 62.9 11.3 62.9l20.6-4.6-17.6-61.5-14.3-59.7-22.3-4.4z"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m223.8 607.2q0 0-0.6-1.1-0.7-1.2-1.7-3.1c-1.4-2.8-3.4-6.6-5.9-11.4-4.9-9.8-11.6-23.1-19.1-37.9-3.7-7.4-7.3-14.4-10.3-21-3-6.6-5.2-12.9-6.1-18.5-0.9-5.6-0.8-10.3-0.3-13.4 0.2-1.6 0.4-2.8 0.7-3.6q0.3-1.2 0.3-1.2c0.1 0-0.4 1.7-0.7 4.8-0.3 3.1-0.4 7.7 0.6 13.2 1 5.5 3.2 11.7 6.2 18.2 3.1 6.5 6.7 13.5 10.4 21 7.4 14.8 14 28.2 18.9 38 2.3 4.8 4.3 8.8 5.6 11.6q1 2 1.5 3.2 0.5 1.1 0.5 1.2z"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m271.7 517.3q0-0.1 0.4 0.9 0.4 1.2 1 2.9c0.9 2.5 2 6.1 3.3 10.7 2.5 9.1 5.3 21.9 7.6 36.1 1.2 7.1 2.3 13.8 3.3 20q0.8 4.6 1.5 8.7c0.5 2.7 1.2 5.2 1.9 7.5 1.4 4.5 2.7 8 3.5 10.6q0.6 1.9 0.9 2.9 0.2 1 0.2 1-0.1 0-0.4-1-0.5-1.1-1.1-2.8c-0.9-2.5-2.4-6-3.9-10.5-0.7-2.2-1.5-4.7-2-7.5q-0.7-4.1-1.6-8.7c-1-6.2-2.1-12.9-3.3-20-2.4-14.2-5-27-7.3-36.1-1.2-4.6-2.3-8.2-3-10.8q-0.5-1.7-0.8-2.9-0.3-1-0.2-1z"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m241.4 497.5q0-0.1 1 0.5 1 0.5 2.7 1.8c2.2 1.7 5.2 4.5 8.6 8.2 1.7 1.8 3.4 3.9 5.2 6.3 1.8 2.4 3.4 5.1 5.1 7.9 3.4 5.7 6.7 12.3 9.2 19.5 2.6 7.2 4.5 14.3 5.3 20.9 0.9 6.6 0.7 12.7 0.1 17.6-0.6 5-1.5 9-2.3 11.7q-0.5 2-0.9 3.1-0.3 1-0.4 1 0 0 0.2-1.1 0.3-1.2 0.7-3.1c0.6-2.7 1.4-6.7 1.9-11.6 0.5-5 0.6-10.9-0.3-17.4-0.9-6.5-2.8-13.6-5.3-20.7-2.5-7.2-5.8-13.7-9-19.4-1.7-2.8-3.3-5.5-5-7.9-1.7-2.3-3.5-4.4-5.1-6.3-3.3-3.8-6.2-6.6-8.3-8.4-2.1-1.8-3.4-2.6-3.4-2.6z"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m181.9 677.6q0.1 0 0.4 1.2c0.2 0.7 0.5 1.9 0.7 3.3 0.5 3 0.8 7.3 0.2 12.4v0.5l-0.5-0.1c-5.7-1-12.5-1.9-19.9-2.2-7.6-0.4-14.6-0.3-20.5 0.1l-1 0.1 0.6-0.8c2.9-3.8 5.3-7 7.2-9.5 1.7-2.2 2.8-3.5 2.9-3.4 0 0-0.9 1.4-2.5 3.7-1.8 2.6-4.1 5.8-6.9 9.7l-0.4-0.7c5.9-0.5 13-0.7 20.7-0.3 7.4 0.4 14.3 1.3 20 2.4l-0.6 0.4c0.7-5 0.5-9.3 0.2-12.2-0.3-2.9-0.7-4.6-0.6-4.6z"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m151 511.1c0 0-18.5 12.3-21 26.5-3.3 19 3.3 85.6 5 100.8 1.7 15.1 11.7 28.5 22.1 29.4 10.4 0.9 92.6-29 92.6-29l-8.2-30.3-59.8 12.1-6-70.1z"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m176.5 559.5l5.2 61.1 59.8-12.1 8.2 30.3c0 0-62.9 24.8-71.7 25.9-8.8 1.1-32.7 5.6-37.8-10.4"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m272.4 567.3l27.5 3c1 0.1 1.8 1 1.7 2.1l-4.9 45.4c-0.1 1-1.1 1.7-2.1 1.6l-27.5-2.9c-1-0.1-1.7-1.1-1.6-2.1l4.9-45.4c0.1-1 1-1.8 2-1.7z"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m272.4 567.3c0.1 0.1-0.6-0.1-1.4 0.6-0.4 0.4-0.5 0.9-0.5 1.7q-0.1 1.2-0.3 2.7c-0.4 4.1-0.9 9.8-1.6 16.9-0.8 7.1-1.6 15.6-2.6 25-0.2 1 0.4 1.8 1.6 1.8q1.8 0.2 3.6 0.4 3.7 0.4 7.6 0.8 7.7 0.8 15.8 1.7c0.5 0.1 1-0.2 1.3-0.6 0.1-0.2 0.2-0.4 0.2-0.7l0.2-1q0.2-2 0.4-4 0.4-4 0.8-7.8 0.9-7.7 1.7-14.8 0.8-7 1.5-13.3 0.1-1.6 0.3-3.1c0.1-0.5 0.1-1.1 0.2-1.5-0.1-0.4-0.2-0.7-0.5-1-0.3-0.3-0.6-0.4-1.1-0.4q-0.7-0.1-1.4-0.2-1.4-0.1-2.7-0.3c-7.1-0.8-12.8-1.5-16.9-2q-2.9-0.4-4.6-0.6-1.5-0.2-1.6-0.3 0.1 0 1.7 0.1 1.7 0.2 4.6 0.4c4.1 0.4 9.8 1 16.8 1.7q1.4 0.1 2.8 0.2 0.7 0.1 1.4 0.2c0.5 0 1.1 0.2 1.5 0.6 0.5 0.4 0.8 1 0.8 1.6 0 0.6-0.1 1-0.2 1.6q-0.1 1.5-0.3 3-0.6 6.4-1.4 13.4-0.7 7.1-1.5 14.8-0.4 3.9-0.9 7.8-0.2 2-0.4 4l-0.1 1c0 0.4-0.2 0.9-0.4 1.2-0.5 0.7-1.4 1.2-2.3 1.1q-8.1-0.9-15.8-1.8-3.9-0.4-7.6-0.8-1.8-0.2-3.6-0.4c-0.6 0-1.5-0.3-2-0.9-0.5-0.5-0.6-1.4-0.5-2 1.1-9.4 2-17.9 2.8-25 0.9-7.1 1.5-12.8 2-16.9q0.2-1.4 0.3-2.6c0.1-0.8 0.3-1.5 0.8-1.8 0.9-0.8 1.6-0.4 1.5-0.5z"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m292 594.9l-3.2-0.3 0.6-5.8 3.2 0.3z"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m292.9 586.5l-3.2-0.4 0.6-5.8 3.3 0.4z"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m291.1 603.4l-3.2-0.4 0.6-5.8 3.2 0.4z"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m290.2 611.7l-3.3-0.4 0.6-5.7 3.3 0.3z"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m140.2 654.3q0 0 0.2 0.6 0.3 0.6 0.8 1.6c0.7 1.3 1.9 3.3 4.3 5 2.3 1.8 5.7 3.2 9.8 3.8 4.2 0.7 9 0.7 14.3 0.1 2.6-0.2 5.4-0.7 8.3-1 2.8-0.5 5.7-1.5 8.7-2.5 6-2 12.3-4.3 19.1-6.8 13.4-4.9 28.1-10.7 43.8-16.8l-0.3 0.6c-1.5-5.3-3-11-4.6-16.7q-1.9-6.9-3.7-13.5l0.7 0.3c-22 4.5-42.3 8.6-59.8 12.1l-0.5 0.1v-0.5c-1.5-18.4-2.8-33.7-3.7-44.5-0.4-5.3-0.7-9.4-0.9-12.4q-0.1-2-0.2-3.2-0.1-1.1 0-1.1 0 0 0.1 1.1 0.2 1.2 0.4 3.2c0.3 2.9 0.7 7.1 1.2 12.4 0.9 10.7 2.3 26 4 44.4l-0.5-0.4c17.4-3.6 37.7-7.7 59.6-12.2l0.5-0.1 0.2 0.5q1.8 6.6 3.7 13.5c1.5 5.8 3 11.4 4.5 16.8l0.1 0.4-0.4 0.2c-15.7 6.1-30.5 11.8-43.9 16.7-6.7 2.5-13.1 4.8-19.1 6.7-3.1 1-5.9 1.9-8.9 2.4-2.9 0.4-5.7 0.8-8.4 1-5.3 0.5-10.2 0.5-14.4-0.2-4.2-0.7-7.7-2.1-10-4-2.3-1.9-3.6-3.9-4.2-5.3q-0.4-1.1-0.7-1.7-0.2-0.5-0.1-0.6z"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m140 523.4c0-0.1 2-0.3 5.3 0.1 3.3 0.3 7.8 1.6 12.2 4.2 4.4 2.6 7.6 6 9.5 8.7 1.9 2.7 2.7 4.6 2.6 4.6-0.2 0.1-1.2-1.7-3.2-4.2-2-2.5-5.2-5.6-9.5-8.2-4.2-2.5-8.5-3.8-11.7-4.4-3.2-0.6-5.2-0.6-5.2-0.8z"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m242.8 611.2c0 0 19.1-18.6 22.5-22.4 3.4-3.8 24-4.8 27-3.4 3.1 1.4 2.7 5.6 0.8 6.2-1.9 0.7-13-0.1-16.4 1.3-3.4 1.3 8.8 0.9 13.7 4.6 5 3.7 2.2 6.1 0.3 6.3 0 0 2.7 2.3 0.6 4.6-2.1 2.2-4.5 1.2-4.5 1.2 0 0 3.4 1.4 2.1 4.2-1.3 2.8-6 1.6-6 1.6 0 0-7.4-2.7-8.6-2.2-1.2 0.4-4.9 6.5-9 9.9-5.2 4.3-11.7 3.2-13.3 3l-4.2 3.7c-1.3-4.4-5-18.6-5-18.6z"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m281.8 574.3l-0.5 4.5-4.9-0.5 0.5-4.5z"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m176.3 771.7h-147.3v-111.1h137.2c5.2 0 9.5 2.2 9.5 4.9z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "m114.6 810.4h-85.6v-149.8l85.1 0.3z"
  }))), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m160.7 660.8c0 0.3-28 0.5-62.6 0.5-34.5 0-62.6-0.2-62.6-0.5 0-0.3 28.1-0.5 62.6-0.5 34.6 0 62.6 0.2 62.6 0.5z"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m175.6 810.9c-0.3 0-0.6-27.5-0.6-61.3 0-33.9 0.3-61.3 0.6-61.3 0.3 0 0.5 27.4 0.5 61.3 0 33.8-0.2 61.3-0.5 61.3z"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m296.5 771.1c0 0.3-27 0.5-60.2 0.5-33.2 0-60.2-0.2-60.2-0.5 0-0.3 27-0.5 60.2-0.5 33.2 0 60.2 0.2 60.2 0.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewPayment);
export default __webpack_public_path__ + "static/media/NewPayment.53361792.svg";
export { ForwardRef as ReactComponent };